import { Card } from '@material-ui/core'
import React from 'react'
import { ComunicationExternalsTable } from '../../../../components/shared/comunicationExternalsTable/comunicationExternalsTable'
import useExternals from '../../../../components/shared/comunicationExternalsTable/comunicationExternalsTable.hooks'
import { DatePeriod, GlobalNotification } from '../../../../model'

export interface ComunicationExternalsPageProps {
  onNotificationChange: (notificacion: GlobalNotification | undefined) => void
  onFetchingChange: (boolean: boolean) => void
  dateRange: DatePeriod
}

export const ComunicationExternalsPage: React.FC<ComunicationExternalsPageProps> = ({
  onNotificationChange,
  onFetchingChange,
  dateRange
}) => {
  const {
    externals,
    refreshExternals,
    isFetchingExternals,
    isFetchingMailingList,
    mailingList,
    setIdMailingList
  } = useExternals({ dateRange })

  return (
    <>
      <Card raised>
        <ComunicationExternalsTable
          externals={externals}
          mailingList={mailingList}
          isFetchingMailingList={isFetchingMailingList}
          onSelectMailingList={setIdMailingList}
          onRefreshExternals={refreshExternals}
          onNotificationChange={onNotificationChange}
        />
      </Card>
    </>
  )
}
